const SkeletonRow = () => (
  <div className="flex items-center">
    <div className="h-3 w-20 bg-[#E4E4E4] rounded shrink-0" />
    <div className="h-3 flex-1 bg-[#F0F0F0] rounded ml-8" />
  </div>
);

const SkeletonCard = ({ rows = 3 }) => (
  <div className="border border-[#F0F0F0] rounded-[6px] overflow-hidden">
    <div className="flex items-center gap-2 px-4 py-3 border-b border-[#F0F0F0]">
      <div className="h-4 w-4 bg-[#E4E4E4] rounded" />
      <div className="h-4 w-28 bg-[#E4E4E4] rounded" />
    </div>
    {Array.from({ length: rows }, (_, i) => (
      <div key={i} className="flex items-center px-4 py-3">
        <SkeletonRow />
      </div>
    ))}
  </div>
);

const MemorySkeleton = () => (
  <div className="flex flex-col gap-8 animate-pulse">
    {/* About You skeleton */}
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <div className="w-[3px] h-[18px] bg-[#E4E4E4] rounded-full" />
        <div className="h-4 w-24 bg-[#E4E4E4] rounded" />
      </div>
      <div className="border border-[#F0F0F0] rounded-[6px] p-4 flex flex-col gap-4">
        {[1, 2, 3].map((i) => (
          <SkeletonRow key={i} />
        ))}
      </div>
    </div>

    {/* Businesses skeleton */}
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <div className="w-[3px] h-[18px] bg-[#E4E4E4] rounded-full" />
        <div className="h-4 w-32 bg-[#E4E4E4] rounded" />
      </div>
      <div className="h-3 w-56 bg-[#F0F0F0] rounded ml-[11px]" />
      <SkeletonCard rows={3} />
    </div>

    {/* Related Entities skeleton */}
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <div className="w-[3px] h-[18px] bg-[#E4E4E4] rounded-full" />
        <div className="h-4 w-32 bg-[#E4E4E4] rounded" />
      </div>
      <div className="h-3 w-52 bg-[#F0F0F0] rounded ml-[11px]" />
      <SkeletonCard rows={2} />
      <SkeletonCard rows={2} />
    </div>
  </div>
);

export default MemorySkeleton;
